import { connect } from 'react-redux';
import { fetchCurrentlyViewingAsset } from 'src/legacy/redux/actions/chatUsers.jsx';
import { fetchConversation } from 'src/legacy/redux/actions/conversations.jsx';
import { fetchAsset, fetchPreviewAsset } from 'src/legacy/redux/actions/assets.jsx';
import LiveView from './view.jsx';
import _ from 'lodash';

const mapStateToProps = (state) => {
  
  return {
    assetId: _.get(state.legacyRootReducer, 'chatUser.item.liveView.assetId'),
    shareId: _.get(state.legacyRootReducer, 'chatUser.item.liveView.shareId'),
    pageNumber: _.get(state.legacyRootReducer, 'chatUser.item.liveView.pageNumber'),
    share: _.get(state.legacyRootReducer, 'conversations.conversation.item'),
    asset: _.get(state.legacyRootReducer, 'asset.item'),
    pages: _.get(state.legacyRootReducer, 'asset.preview.item.pages')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    fetchConversation: (id) => {
      return dispatch(fetchConversation(id));
    },

    fetchAsset: (id) => {
      return dispatch(fetchAsset(id));
    },

    fetchPreviewAsset: (id) => {
      return dispatch(fetchPreviewAsset(id));
    }
  }
}

const LivePage = connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveView)

export default LivePage;